import dayjs from 'dayjs';

// Enums and types matching backend
export enum ScheduleType {
  WEEKLY = 'Weekly',
  BIWEEKLY = 'BiWeekly',
  MONTHLY = 'Monthly',
}

export enum DayOfWeek {
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
  SUNDAY = 'Sunday',
}

export enum MonthlyType {
  ON_DATE = 'onDate',
  ON_DAY = 'onDay',
}

export enum OrdinalWeek {
  FIRST = 'first',
  SECOND = 'second',
  THIRD = 'third',
  FOURTH = 'fourth',
  LAST = 'last',
}

// Collection configuration interfaces
export interface WeeklyConfig {
  days: DayOfWeek[];
}

export interface BiWeeklyConfig {
  week1Days: DayOfWeek[];
  week2Days: DayOfWeek[];
}

export interface MonthlyOnDateConfig {
  type: MonthlyType.ON_DATE;
  date: number; // 1-31
}

export interface MonthlyOnDayConfig {
  type: MonthlyType.ON_DAY;
  ordinal: OrdinalWeek;
  day: DayOfWeek;
}

export type MonthlyConfig = MonthlyOnDateConfig | MonthlyOnDayConfig;

export interface CollectionConfig {
  weekly?: WeeklyConfig;
  biWeekly?: BiWeeklyConfig;
  monthly?: MonthlyConfig;
}

export interface Schedule {
  id: string;
  siteId: number;
  scheduleType: ScheduleType;
  collectionConfig: CollectionConfig;
  startDate: string | null;
  endDate: string | null;
  description?: string;
  isActive: boolean;
  createdAt: number;
  updatedAt: number;
  createdBy: string;
  updatedBy: string;
}

export interface ScheduleFormData {
  scheduleType: ScheduleType;
  collectionConfig: CollectionConfig;
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  description?: string;
  isActive: boolean;
}

export interface SiteScheduleModalRef {
  open: (siteId: number, siteName: string) => Promise<any>;
}
